import { render } from "./FooterBlock.vue?vue&type=template&id=4bd91c8a"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=4bd91c8a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__